import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   width: 100%;
   height: 422px;
   overflow: auto;
   padding-right: 15px;

   .action {
      margin-bottom: 12px;
   }

   .topicSelect {
      margin-bottom: 12px;
   }

   .topicBody {
      padding: 10px;
      background: #fafafa;
   }

   .topicLabel {
      display: block;
      font-size: 12px;
      color: #475569;
      font-weight: 600;
      margin-bottom: 6px;
   }

   .topicSelectInput {
      width: 100%;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 13px;
      outline: none;
      box-sizing: border-box;
      background: #fff;
      color: #111827;
   }

   .topicSelectInput:focus {
      border-color: #96588a;
      box-shadow: 0 0 0 1px #96588a;
   }

   .sectionCard {
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background: #fff;
      overflow: hidden;
   }

   .sectionToggle {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: none;
      background: #f8fafc;
      color: #111827;
      padding: 10px 12px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      text-align: left;
   }

   .sectionToggleIcon {
      font-size: 16px;
      line-height: 1;
      color: #6b7280;
      margin-left: 8px;
   }

   .topicChecklist {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px 12px;
      padding: 10px;
      background: #fafafa;
   }

   .topicItem {
      display: flex;
      align-items: center;
      gap: 7px;
      font-size: 13px;
      color: #374151;
      cursor: pointer;
      user-select: none;
      line-height: 1.35;
   }

   .topicItem input {
      width: 14px;
      height: 14px;
      accent-color: #96588a;
      cursor: pointer;
      margin: 0;
      flex-shrink: 0;
   }

   .toolbar {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
   }

   .generateBtn {
      border: none;
      border-radius: 6px;
      padding: 8px 12px;
      background: #96588a;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
   }

   .generateBtn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
   }

   .webhook-section {
      margin-bottom: 12px;
   }

   .webhookPanelBody {
      padding: 10px;
      background: #f8fafc;
      display: flex;
      flex-direction: column;
      gap: 10px;
   }

   .webhookGroup {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      background: #ffffff;
      padding: 10px;
   }

   .groupTitle {
      font-size: 12px;
      font-weight: 700;
      color: #334155;
      letter-spacing: 0.02em;
      margin-bottom: 8px;
      text-transform: uppercase;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 13px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      min-width: 0;
      flex: 1;
   }

   .secret-hint {
      color: #4b5563;
      font-size: 12px;
      margin-bottom: 6px;
      line-height: 1.4;
   }

   .secret-input {
      width: 100%;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 13px;
      margin-bottom: 8px;
      outline: none;
      box-sizing: border-box;
   }

   .secret-input:focus {
      border-color: #96588a;
      box-shadow: 0 0 0 1px #96588a;
   }

   .warning {
      color: #d97706;
      font-size: 13px;
      margin-bottom: 8px;
   }

   .collapsedValue {
      padding: 10px 12px;
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      background: #ffffff;
   }

   .statusBadge {
      border-radius: 999px;
      font-size: 11px;
      font-weight: 700;
      padding: 5px 9px;
      line-height: 1;
      letter-spacing: 0.02em;
   }

   .statusBadge.ready {
      background: #dcfce7;
      color: #166534;
      border: 1px solid #86efac;
   }

   .statusBadge.missing {
      background: #fff7ed;
      color: #9a3412;
      border: 1px solid #fdba74;
   }

   .error {
      color: #dc2626;
      font-size: 13px;
      margin-bottom: 8px;
   }

   .instructions-section {
      margin: 12px 0 0;
   }

   .instructions-section h5 {
      margin: 0 0 8px 0;
      color: #333;
      font-size: 14px;
      font-weight: 600;
   }

   .steps-list {
      margin: 0;
      padding-left: 18px;
      font-size: 14px;
      line-height: 1.4;
   }

   .steps-list li:not(:last-of-type) {
      margin-bottom: 6px;
   }
`;

export const Loader = styled.span`
   width: 68px;
   height: 68px;
   border: 5px solid #9ca3af;
   border-bottom-color: #262627;
   border-radius: 50%;
   display: block;
   box-sizing: border-box;
   animation: rotation 1s linear infinite;
   margin: 0 auto;

   @keyframes rotation {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
`;